import { useContext, useEffect } from "react";
import { SOCKET_EVENTS, SocketContext } from "../components/SocketProvider";
import { MODAL_TYPES } from "../utils/emitter";
import useModalActions from "./useModalActions";
import useCurrentUserData from "./useCurrentUserData";
import PersonalAccount from "../store/PersonalAccount";
import Game from "../store/Game";
import useCurrentGame from "./useCurrentGame";
import INTOUCH_API from "../services/Api";
import { useLocation } from "react-router-dom";
import ROUTES from "../utils/routes";

export default function useGlobalGameEvents() {
  const { socket } = useContext(SocketContext);
  const { openModal } = useModalActions();
  const { getUserData } = useCurrentUserData();
  const { setGame } = useCurrentGame();

  const onPartnerBoughtGame = async (data) => {
    const userData = getUserData();
    if (data.partnerId === userData.id || data.buyerId === userData.id) {
      await PersonalAccount.getPersonalAccountData();
      const game = Game.game;
      if (game) {
        const updatedGame = PersonalAccount.games.find(
          (gm) => gm.id === game.id
        );
        if (updatedGame) {
          Game.setGame(updatedGame);
          setGame(updatedGame);
          if (window.location.pathname === ROUTES.MATCHES_PAGE) {
            await INTOUCH_API.requestManager("game_notification_by_gameid", {
              gameId: data.gameId,
              isViewed: true,
            });
          }
          await INTOUCH_API.requestManager(
            "get_game_events",
            null,
            (response) => {
              Game.setGameEventsData(response.data);
            }
          );
        }
      }
    }
    if (data.partnerId === userData.id) {
      openModal(MODAL_TYPES.PARTNER_BOUGHT_GAME);
    }
  };
  useEffect(() => {
    socket.current.on(SOCKET_EVENTS.PARTNER_BOUGHT_GAME, onPartnerBoughtGame);
    return () => {
      socket.current.off(
        SOCKET_EVENTS.PARTNER_BOUGHT_GAME,
        onPartnerBoughtGame
      );
    };
  }, [socket]);
}
